import React, { useState, useRef } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import "../about/SplashPdfViewer.css";
import CTAButton from "../components/sticky-button";
import PageHeader from "../about/PageHeader";

const FeedBack = () => {
  const topRef = useRef(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Updated Content List: All items are now PDFs
const pdfList = [
  { 
    id: 1, 
    title: "Alumni Feedback", 
    src: "/pdf/Footer/Feedback/Alumni_Feedback_on_Syllabus_Report2023-24.pdf", 
    isWeb: false 
  },
  { 
    id: 2, 
    title: "Employer Feedback", 
    src: "/pdf/Footer/Feedback/Employer_Feedback_on_Syllabus_Report2023-24.pdf", 
    isWeb: false 
  },
  { 
    id: 3, 
    title: "Student Feedback", 
    src: "/pdf/Footer/Feedback/Students_Feedback_on_Syllabus_Report_AY23-24.pdf", 
    isWeb: false 
  },
  { 
    id: 4, 
    title: "Faculty Feedback", 
    src: "/pdf/Footer/Feedback/Faculty_Feedback_on_Syllabus_MCA_2_year_course_2023-24.pdf", 
    isWeb: false 
  }
];

  const [activePdf, setActivePdf] = useState(pdfList[0]);

  const handlePdfSelection = (pdf) => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    // Since all are PDFs now, we just update the viewer state
    setActivePdf(pdf);
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <Navbar />
      <CTAButton />

      <div className="spv-modern-portal">
        <div ref={topRef}>
          <PageHeader 
            title="Feedback" 
            crumbs={[{ label: 'Home', href: '/' }, { label: 'Feedback' }]} 
          />
        </div>

        <div className="spv-main-content">
          {isMobileMenuOpen && (
            <button
              type="button"
              className="spv-sidebar-overlay"
              aria-label="Close menu"
              onClick={() => setIsMobileMenuOpen(false)}
            />
          )}

          <aside className={`spv-sidebar-modern ${isMobileMenuOpen ? "mobile-open" : ""}`}>
            <div className="spv-sidebar-topbar">
              <div className="spv-sidebar-header-text">STAKEHOLDER FEEDBACK</div>
              <button
                type="button"
                className="spv-mobile-close"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                ×
              </button>
            </div>
           
            <nav className="spv-nav-group">
              {pdfList.map((pdf) => (
                <button
                  key={pdf.id}
                  className={`spv-nav-card ${activePdf.id === pdf.id ? "is-active" : ""}`}
                  onClick={() => handlePdfSelection(pdf)}
                >
                  <div className="spv-card-content">
                    <img 
                      src="/images/icons/pdf.svg" 
                      alt="pdf icon" 
                      className="spv-doc-icon-img" 
                    />
                    <span className="spv-card-text">{pdf.title}</span>
                    <img 
                      src="/images/icons/move.webp" 
                      alt="arrow" 
                      className="spv-doc-icon-img" 
                    />
                  </div>
                </button>
              ))}
            </nav>
          </aside>

          <main className="spv-viewer-area">
            <header className="spv-viewer-topbar">
              <div className="spv-info-stack">
                <h2 className="spv-doc-title">{activePdf.title}</h2>
              </div>
              <div className="spv-action-group">
                <button
                  type="button"
                  className="spv-btn spv-btn-outline spv-mobile-toggle-inline"
                  onClick={() => setIsMobileMenuOpen(true)}
                >
                  Document List
                </button>
                <button 
                  className="spv-btn spv-btn-outline" 
                  onClick={() => window.open(activePdf.src)}
                >
                  Full Screen
                </button>
              </div>
            </header>

            <div className="spv-pdf-viewport">
              <div className="spv-pdf-card no-select">
                <iframe
                  src={`${activePdf.src}#toolbar=0&navpanes=0&scrollbar=0`}
                  className="spv-iframe-content secure-frame"
                  title="Feedback Document"
                  onContextMenu={(e) => e.preventDefault()}
                />
              </div>
            </div>
          </main>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FeedBack;